import epsClient from 'enrollment-platform/api/eps.client'
import type {
  BulkImportDownloadResponseDto,
  BulkImportSessionResponseDto,
  ListBulkImportSessionsResponseDto,
  OverrideCategory,
} from './dto/bulk-import-session.dto'

const BASE_PATH = '/api/v1/plan-overrides/bulk-imports'

export const uploadBulkImportCsv = async (
  file: File,
  overrideType: OverrideCategory = 'plan-benefit'
): Promise<BulkImportSessionResponseDto> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('overrideType', overrideType)
  const { data } = await epsClient.post<BulkImportSessionResponseDto>(
    `${BASE_PATH}/upsert`,
    formData
  )
  return data
}

export const listBulkImportSessions = async (params: {
  page: number
  limit: number
  overrideType?: OverrideCategory
}): Promise<ListBulkImportSessionsResponseDto> => {
  const { data } = await epsClient.get<ListBulkImportSessionsResponseDto>(
    BASE_PATH,
    { params }
  )
  return data
}

export const getBulkImportSession = async (
  id: string
): Promise<BulkImportSessionResponseDto> => {
  const { data } = await epsClient.get<BulkImportSessionResponseDto>(
    `${BASE_PATH}/${id}`
  )
  return data
}

export const downloadBulkImportFile = async (
  id: string,
  role: 'original' | 'errors' | 'success'
): Promise<BulkImportDownloadResponseDto> => {
  const { data } = await epsClient.get<BulkImportDownloadResponseDto>(
    `${BASE_PATH}/${id}/files/${role}/download`
  )
  return data
}
